import { render, staticRenderFns } from "./DashboardUser.vue?vue&type=template&id=6dc85efe&scoped=true&"
import script from "./DashboardUser.vue?vue&type=script&lang=js&"
export * from "./DashboardUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc85efe",
  null
  
)

export default component.exports